module.exports = __webpack_public_path__ + "img/icon_wallet.4c235afc.svg";